<template>
  <div class="property-details-media-zoom-controls-ui">
    <VBtn class="map-zoom-control" :disabled="disabled" @click="emitZoomIn">
      <PlusCircle />
    </VBtn>
    <VBtn class="map-zoom-control" :disabled="disabled" @click="emitZoomOut">
      <MinusCircle />
    </VBtn>
  </div>
</template>

<script lang="ts" setup>
  // Components
  import VBtn from '~/misc/v-btn';
  import PlusCircle from '~/misc/icons/plus-circle/PlusCircle.vue';
  import MinusCircle from '~/misc/icons/minus-circle/MinusCircle.vue';

  defineProps({
    disabled: {
      type: Boolean,
      required: true,
    },
  });

  const emit = defineEmits<{
    (e: 'zoomIn'): void;
    (e: 'zoomOut'): void;
  }>();

  const emitZoomIn = () => emit('zoomIn');
  const emitZoomOut = () => emit('zoomOut');
</script>
